import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { distinct, flatten, forEach, removeFirstOccurrence } from '@beef/utils';
import { SetNodeRectsCommand, UpdateNodeRectsCommand, UpdateObservedIdsCommand } from '@beefco/sdk-tools/commands';
import { BusSources } from '@beefco/sdk-tools/sources';
import { getDOMNodeRect } from "../helpers";
/**
 * Class responsible for master-to-slave communication between
 * cms-front (acts as master) and renderer (acts as slave)
 *
 * Master attaches subscribers by nodeIds or uniqueIds to watch for nodeRect changes
 * Slave runs polling and scroll/resize listeners, syncing boxes of observed nodes
 *
 * // TODO: optimization is needed:
 *     1. reduce handler calls to changed rects
 *     2. reduce data transfer from slave to master to changed rects
 */
export var NodeRectObserver = /*#__PURE__*/function () {
  function NodeRectObserver(bus, nodeRegistry) {
    var _this = this;
    _classCallCheck(this, NodeRectObserver);
    this.bus = bus;
    this.nodeRegistry = nodeRegistry;
    /** Kept on master */
    _defineProperty(this, "nodeSubscribers", {});
    _defineProperty(this, "uniqueSubscribers", {});
    _defineProperty(this, "nodeRects", []);
    _defineProperty(this, "timer", void 0);
    /** Kept on slave */
    _defineProperty(this, "observedNodeIds", []);
    _defineProperty(this, "observedUniqueIds", []);
    _defineProperty(this, "isListening", false);
    _defineProperty(this, "updateNodeRect", function () {
      return _this.bus.execute(new UpdateNodeRectsCommand(null));
    });
    /**
     * No other choice. Method needs to be bound as event handler.
     * While arrow function can not be used with decorators.
     */

    // FIXME: Довольно плохая проблема. Причину точно не помню - вроде падал SSR,
    //  в связи с синхронным подключением шины
    if (typeof window === 'undefined') return;

    // FIXME: По сути проверять таким образом терпимо, но лучше переписать
    if (bus.source === BusSources.PROJECT) {
      // Project
      bus.on(UpdateObservedIdsCommand, function (_ref) {
        var nodeIds = _ref.nodeIds,
          uniqueIds = _ref.uniqueIds;
        _this.observedNodeIds = nodeIds;
        _this.observedUniqueIds = uniqueIds;
      });
      bus.on(UpdateNodeRectsCommand, function () {
        _this.recalculateNodeRects();
      });
      return;
    }

    // CmsFront
    bus.on(SetNodeRectsCommand, function (_ref2) {
      var nodeRects = _ref2.nodeRects;
      // TODO: change to incremental unpacking, not full replace
      _this.nodeRects = nodeRects;
      _this.notifySubscribers();
    });
  }
  _createClass(NodeRectObserver, [{
    key: "subscribe",
    value: function subscribe(_ref3, handler) {
      var uniqueId = _ref3.uniqueId,
        nodeId = _ref3.nodeId;
      var subscriberType = uniqueId ? 'uniqueSubscribers' : 'nodeSubscribers';
      if (uniqueId) {
        this.uniqueSubscribers[uniqueId] = [].concat(_toConsumableArray(this[subscriberType][uniqueId] || []), [handler]);
      } else {
        this.nodeSubscribers[nodeId] = [].concat(_toConsumableArray(this[subscriberType][nodeId] || []), [handler]);
      }
      this.scheduleUpdateIds();
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(_ref4, handler) {
      var uniqueId = _ref4.uniqueId,
        nodeId = _ref4.nodeId;
      var subscriberType = uniqueId ? 'uniqueSubscribers' : 'nodeSubscribers';
      var id = uniqueId || nodeId;
      var subject = this[subscriberType][id];
      if (!subject) throw Error('Attempting to unsubscribe non existing subject');
      if (subject.indexOf(handler) === -1) throw Error('Attempting to unsubscribe non existing handler');
      this[subscriberType][id] = removeFirstOccurrence(subject, handler);
      if (!this[subscriberType][id].length) {
        delete this[subscriberType][id];
        this.scheduleUpdateIds();
      }
    }
  }, {
    key: "scheduleUpdateIds",
    value: function scheduleUpdateIds() {
      var _this2 = this;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(function () {
        var nodeIds = Object.keys(_this2.nodeSubscribers);
        var uniqueIds = Object.keys(_this2.uniqueSubscribers);
        _this2.bus.execute(new UpdateObservedIdsCommand({
          nodeIds: nodeIds,
          uniqueIds: uniqueIds
        }));
        _this2.updateNodeRect();
      }, 0);
    }
  }, {
    key: "notifySubscribers",
    value: function notifySubscribers() {
      var _this3 = this;
      forEach(this.nodeSubscribers, function (subscribers, nodeId) {
        if (!subscribers) {
          // FIXME: Происходит каждый раз, когда нажатый элемент уходит за пределы экрана
          /** FIXME: есть очень странный кейс, в котором ключ существует,
           *   а вот элементов в нем нет и вообще это не массив
           */
          console.error('Непредвиденная ошибка, блок подписчиков не задан');
          return;
        }
        var rects = _this3.nodeRects.filter(function (rect) {
          return rect.nodeId === nodeId;
        });
        subscribers.forEach(function (handler) {
          return handler(rects);
        });
      });
      forEach(this.uniqueSubscribers, function (subscribers, uniqueId) {
        if (!subscribers) {
          // FIXME: Происходит каждый раз, когда нажатый элемент уходит за пределы экрана
          console.error('uniqueSubscribers array is null');
          return;
        }
        var rects = _this3.nodeRects.filter(function (rect) {
          return rect.uniqueId === uniqueId;
        });
        subscribers.forEach(function (handler) {
          return handler(rects);
        });
      });
    }
  }, {
    key: "recalculateNodeRects",
    value: function recalculateNodeRects() {
      var _this4 = this;
      var allObservedUniqueIds = distinct(flatten([].concat(_toConsumableArray(this.observedNodeIds.map(function (nodeId) {
        return _this4.nodeRegistry.getNodeUniqueIds(nodeId);
      })), [this.observedUniqueIds])));
      var nodeRects = allObservedUniqueIds.reduce(function (rects, uniqueId) {
        var domNodes = _this4.nodeRegistry.findNodesByUniqueId(uniqueId);
        return [].concat(_toConsumableArray(rects), _toConsumableArray(domNodes.map(function (node) {
          return _objectSpread(_objectSpread({}, getDOMNodeRect(node)), {}, {
            uniqueId: uniqueId,
            nodeId: _this4.nodeRegistry.getNodeIdByUniqueId(uniqueId)
          });
        })));
      }, []);
      this.bus.execute(new SetNodeRectsCommand({
        nodeRects: nodeRects
      }));
      this.updateWatchers();
    }
  }, {
    key: "updateWatchers",
    value: function updateWatchers() {
      // FIXME: missing mutation observer
      if (!this.observedUniqueIds) {
        window.removeEventListener('scroll', this.updateNodeRect);
        window.removeEventListener('resize', this.updateNodeRect);
        this.isListening = false;
      } else if (!this.isListening) {
        window.addEventListener('scroll', this.updateNodeRect);
        window.addEventListener('resize', this.updateNodeRect);
        this.isListening = true;
      }
    }
  }]);
  return NodeRectObserver;
}();